<template>
  <v-navigation-drawer
    v-model="show"
    right
    temporary
    absolute
    hide-overlay
    width="25%"
    stateless
  >
    <v-container class="pa-6">
      <v-row dense>
        <v-col cols="auto">
          <h2>FAQs</h2>
        </v-col>
        <v-spacer> </v-spacer>
        <v-col cols="auto">
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-medium">
            Why are there only 20
            {{ t("core_values.title_s") | lower }} options?
          </div>
          <div class="font-weight-light">
            After looking at the {{ t("core_values.title") | lower }} of 100 top
            companies across the United States, we came up with the top 20
            {{ t("core_values.title") }}. Althrough the words might differ
            slightly, the underlying meanings are close.
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-medium">
            How many {{ t("core_values.title") | lower }} should I have?
          </div>
          <div class="font-weight-light">
            We limit our businesses to 7, but on average a business will choose
            4 {{ t("core_values.title") | lower }}.
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-medium">
            Can I rename the {{ t("core_values.title_s") | lower }} later?
          </div>
          <div class="font-weight-light">
            Yes, the list of 20
            {{ t("core_values.title_s") | lower }} categories here is to help
            you and us organize your {{ t("core_values.title") | lower }}. After
            you make your selections you can customize the name.
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-medium">
            Why is it important to establish your
            {{ t("core_values.title") | lower }}?
          </div>
          <div class="font-weight-light">
            {{ t("core_values.title") }} are the roots of your business. To
            ensure your organization continually moves in the direction you
            inteded when you started, you need a strong root system. These roots
            should be why you are in business and aspirational in nature.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "CoreValueFaqDrawer",
  props: { show: { type: Boolean, default: false } }
};
</script>
